/**
 * Derived lookup of household-member id → display name, aggregated across all
 * households. `assignedTo` on documents holds member ids; the UI should show names
 * (#245). Sourced from householdsStore, which App.svelte loads on mount.
 */
import { derived } from 'svelte/store';
import { householdsStore } from './householdsStore';

/** Map of member id → display name across all households. */
export const memberNames = derived(householdsStore, ($households) => {
  const map = new Map<string, string>();
  for (const household of $households) {
    for (const member of household.members ?? []) {
      if (member?.id) map.set(member.id, member.name || member.id);
    }
  }
  return map;
});

/** Resolve a single member id to its display name, falling back to the id itself. */
export function resolveMemberName(id: string, names: Map<string, string>): string {
  return names.get(id) || id;
}

/** Resolve a list of member ids to a comma-separated display string. */
export function formatAssignees(
  ids: string[] | undefined | null,
  names: Map<string, string>,
): string {
  if (!ids || ids.length === 0) return '';
  return ids.map((id) => resolveMemberName(id, names)).join(', ');
}
